<!-- eslint-disable indent -->
<template>
  <div>
    <div class="">
      <div class="flex gap-2 ">

        <label class="flex-grow text-lg text-normal-emphasis font-bold pb-2">{{ props.name }}
          <span v-if="showEdit && props.showCompleted" class="icon mx-2">
            <i v-if="props.setupStatus === 'Completed'" class="fa-solid fa-circle-check text-confirm"></i>
            <i v-if="props.setupStatus === 'InProgress'" class="fa-solid fa-circle-exclamation text-caution"></i>
            <i v-if="props.setupStatus === 'NotStarted'" class="fa-solid fa-circle-xmark text-critical-text"></i>
          </span>
        </label>

        <button v-if="showEdit" :disabled="isOffline" class="text-action " v-on:click="$emit('editSection')"
          data-testId="edit-button">
          <span class="icon is-small">
            <i class="fas fa-pencil font-light"></i>
          </span>
        </button>
      </div>
    </div>
    <div class="">
      <div class="w-full flex flex-col gap-2 text-sm ">
        <slot></slot>
      </div>
    </div>

    <hr v-if="!hideBreak" class="border-border-light mt-2"></hr>
  </div>
</template>

<script setup lang="ts">
import { Ref, inject } from "vue";

const isOffline = inject("isOffline") as Ref<boolean>;
defineEmits(["editSection"]);

interface Props {
  name: string;
  showCompleted: boolean;
  setupStatus: "Completed" | "InProgress" | "NotStarted";
  showEdit: boolean;
  hideBreak?:boolean;
}

const props = defineProps<Props>();
</script>
